<cdk-virtual-scroll-viewport itemSize="57" class="ship-viewport">
  <div class="list-group-item list-group-item-action bg-dark text-white" *cdkVirtualFor="let s of selected"
       (mouseover)="showBubble(s)" (mouseleave)="hideBubble(s)">
    <div class="row">
      <div class="col" (click)="openParamsModal(s)" style="cursor: pointer">
        MMSI {{s.info.id}}
        <fa-icon [fixedWidth]="true" icon="map-marker"
                 [styles]="{'color': getColor(s.index, 'markerColor')}"></fa-icon>
        <fa-icon [fixedWidth]="true" icon="route"
                 [styles]="{'color': getColor(s.index, 'trackColor')}"></fa-icon>
      </div>
      <div class="col-auto">
        <a class="btn btn-sm btn-link text-white" [href]="s.info.url" target="_blank" title="Get Ship info">
          <fa-icon [fixedWidth]="true" icon="info-circle"></fa-icon>
        </a>
      </div>
    </div>
  </div>
</cdk-virtual-scroll-viewport>
